import React from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSection from 'eco-design/base/eco-section';
import style from './index.module.scss';
import { useLang } from '@/i18n';

interface Props {}

const PowerWorld: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.PowerWorld');

    const items = [
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1744012216300/user.svg',
            title: t('title1'),
            desc: t('desc1'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1744012216131/dq.svg',
            title: t('title2'),
            desc: t('desc2'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1744012216509/jz.svg',
            title: t('title3'),
            desc: t('desc3'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1744012216667/jb.svg',
            title: t('title4'),
            desc: t('desc4'),
        },
    ];

    return (
        <div className={`${style.comp} DtmModuleData-section`} id="PowerWorld" data-section-id="PowerWorld">
            <EcoSpace />
            <EcoSection title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className="container">
                {items.map((i, idx) => (
                    <div className="item" key={idx}>
                        <img className="item-icon" src={i.icon} alt="" />
                        <div className="item-title">{i.title}</div>
                        <div className="item-desc">{i.desc}</div>
                    </div>
                ))}
            </div>
            <EcoSpace />
        </div>
    );
};
export default PowerWorld;
